<main>
    <section class="hero-servicios">
        <div class="imagen-hero-servicios"></div>
        <div class="imagen-hero-servicios_inferior"></div>
        <div class="texto-hero-servicios">
            <div class="circulo-azul-hero-servicios"></div>
            <h1>Nuestros <span>servicios</span></h1>
            <p>En <strong>Corporación Rehobot</strong> ofrecemos soluciones integrales y especializadas en proyectos de infraestructura hídrica, electromecánica y eléctrica. Nuestro enfoque combina <strong>experiencia técnica, equipos de alta precisión</strong> y un firme compromiso con la calidad, la eficiencia y la sostenibilidad.</p>
            <p>Contamos con un catálogo diversificado que nos permite intervenir en todas las etapas de un proyecto: <strong>diseño, ejecución, implementación y mejoras continuas, como también el mantenimiento y rehabilitación</strong>. Ya sea para el sector construcción, industrial, minero, agroindustrial y entidades del estado, adecuando cada servicio a las necesidades específicas de nuestros clientes, garantizando resultados confiables y duraderos.</p>
        </div>
    </section>

    <section class="seccion-servicios-principales">
        <div class="contenedor">
            <h2>Conoce nuestras principales líneas de servicios.</h2>
            
            <div class="contenido-servicios-interactivo">
                
                <div class="lista-servicios">
                    
                    <div *ngFor="let servicio of servicios">
                        
                        <div class="servicio-item" 
                             [attr.data-servicio]="servicio.id"
                             [class.activo]="servicioSeleccionadoId === servicio.id"
                             (click)="seleccionarServicio(servicio.id)">
                            <h3>{{ servicio.titulo }}</h3>
                        </div>

                        <div class="informacion-servicio info-movil" 
             [class.activo]="servicioSeleccionadoId === servicio.id"
             [id]="'info-' + servicio.id">
                            
                            <div class="detalle-servicio" *ngIf="servicio.tipo === 'lista'">
                                <ul class="lista-detalles">
                                    <li *ngFor="let detalle of servicio.detalles">{{ detalle }}</li>
                                </ul>
                            </div>

                            <div class="detalle-servicio tableros-electricos" *ngIf="servicio.tipo === 'acordeon'">
                                <div class="tableros-principales">
                                    <div class="tablero-item" *ngFor="let tablero of servicio.tableros">
                                        <div class="tablero-header" (click)="toggleTablero(tablero)">
                                            <span class="icono-triangulo" [class.rotado]="tablero.abierto">▶</span> 
                                            {{ tablero.titulo }}
                                        </div>
                                        <div class="tablero-contenido" [class.activo]="tablero.abierto">
                                            <p>{{ tablero.descripcion }}</p>
                                            <ul [class.lista-numerada]="tablero.titulo.includes('principal')">
                                                <li *ngFor="let item of tablero.items">{{ item }}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div> </div>

                <div class="informacion-servicio informacion-escritorio" *ngIf="servicioActual">
                    
                    <div class="detalle-servicio" *ngIf="servicioActual.tipo === 'lista'">
                        <ul class="lista-detalles">
                            <li *ngFor="let detalle of servicioActual.detalles">{{ detalle }}</li>
                        </ul>
                    </div>

                    <div class="detalle-servicio tableros-electricos" *ngIf="servicioActual.tipo === 'acordeon'">
                        <div class="tableros-principales">
                            <div class="tablero-item" *ngFor="let tablero of servicioActual.tableros">
                                <div class="tablero-header" (click)="toggleTablero(tablero)">
                                    <span class="icono-triangulo" [class.rotado]="tablero.abierto">▶</span> 
                                    {{ tablero.titulo }}
                                </div>
                                <div class="tablero-contenido" [class.activo]="tablero.abierto">
                                    <p>{{ tablero.descripcion }}</p>
                                    <ul [class.lista-numerada]="tablero.titulo.includes('principal')"> 
                                        <li *ngFor="let item of tablero.items">{{ item }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
            <div class="boton-mas-info">
                    <button class="btn-mas-informacion"><a routerLink="/contacto">Más información aquí</a></button>
            </div>
        </div>
    </section>
</main>